import I18n from 'I18n';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import HR from 'UIComponents/elements/HR';
import { H3 } from 'UIComponents/elements/headings';
import UIFlex from 'UIComponents/layout/UIFlex';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { CMS_HUB_PROFESSIONAL, MARKETING_HUB_PROFESSIONAL, OPERATIONS_HUB_PROFESSIONAL, SALES_HUB_PROFESSIONAL, SERVICE_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
import { getProductLineFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { POPULAR_FEATURES_PANEL } from '../../constants/ErrorBoundaryNames';
import { getPopularFeaturesByProductLineSelector } from '../../selectors/FeatureSelectors';
import { withErrorBoundary } from '../../upgrade-page/ErrorBoundary';
import { PopularFeatureCard } from './PopularFeatureCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApiNameToProductName = {
  [MARKETING_HUB_PROFESSIONAL]: 'pricingPage.products.MARKETING.PROFESSIONAL',
  [SALES_HUB_PROFESSIONAL]: 'pricingPage.products.SALES.PROFESSIONAL',
  [SERVICE_HUB_PROFESSIONAL]: 'pricingPage.products.SERVICE.PROFESSIONAL',
  [CMS_HUB_PROFESSIONAL]: 'pricingPage.products.CMS.PROFESSIONAL',
  [OPERATIONS_HUB_PROFESSIONAL]: 'pricingPage.products.OPERATIONS.PROFESSIONAL'
};
const PopularFeaturesPanel = ({
  upgradeConfig,
  productLevel,
  apiName
}) => {
  const popularFeatures = useSelector(state => {
    return getPopularFeaturesByProductLineSelector(state, {
      productLine: getProductLineFromApiNameString(apiName),
      upgradePointApiName: apiName,
      upgradePointFeature: upgradeConfig.featureStoreFeature,
      productLevel
    });
  });
  const featureNames = popularFeatures.map(feature => feature.shortName);
  useEffect(() => {
    if (featureNames.length > 0 && popularFeatures) {
      getUsageTracker().track('upgradesInteraction', {
        action: 'viewed popular features panel',
        apiName,
        upgradeSource: upgradeConfig.featureStoreFeature,
        features: featureNames
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureNames, popularFeatures]);
  if (!popularFeatures.length) return null;
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "column",
    align: "center",
    children: [/*#__PURE__*/_jsx(HR, {
      distance: "extra-large",
      style: {
        width: '75%'
      }
    }), /*#__PURE__*/_jsx(H3, {
      className: "m-bottom-8",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "interstitial.otherPopularFeatures",
        options: {
          apiName: I18n.text(ApiNameToProductName[apiName])
        }
      })
    }), /*#__PURE__*/_jsx(UIFlex, {
      direction: "row",
      align: "stretch",
      gap: 32,
      children: popularFeatures.map(featureUpgradeConfig => /*#__PURE__*/_jsx(PopularFeatureCard, {
        featureRecord: featureUpgradeConfig,
        apiName: apiName
      }, featureUpgradeConfig.shortName))
    })]
  });
};
export default withErrorBoundary(PopularFeaturesPanel, {
  boundaryName: POPULAR_FEATURES_PANEL
});